import { z } from 'zod';
import { isValidCpf, normalizeCpf } from '../cpf';
import { isIsoDate } from '../dates';

export const uuidSchema = z.uuid('Identificador inválido');
export const isoDate = z.string().refine(isIsoDate, 'Data inválida (use AAAA-MM-DD)');
export const isoDateTime = z.iso.datetime({ offset: true, message: 'Data/hora inválida' });

export const emailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .max(254)
  .pipe(z.email('E-mail inválido'));

/** Política de senha (NIST SP 800-63B): comprimento mínimo, sem regras de composição. */
export const passwordSchema = z
  .string()
  .min(10, 'A senha deve ter pelo menos 10 caracteres')
  .max(128, 'A senha deve ter no máximo 128 caracteres');

/** CPF digitado com ou sem pontuação; sai normalizado em 11 dígitos. */
export const cpfSchema = z
  .string()
  .trim()
  .min(1, 'CPF é obrigatório')
  .refine(isValidCpf, 'CPF inválido')
  .transform(normalizeCpf);

export const nonEmptyText = (max: number, label = 'Campo') =>
  z.string().trim().min(1, `${label} é obrigatório`).max(max, `${label} deve ter no máximo ${max} caracteres`);

export const optionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max, `Máximo de ${max} caracteres`)
    .transform((v) => (v === '' ? undefined : v))
    .optional();

export const urlSchema = z
  .url({ protocol: /^https?$/, message: 'URL inválida (use http ou https)' })
  .max(2000);

/** Booleano vindo da query string: "true"/"1" → true; "false"/"0"/ausente → false (z.coerce.boolean trataria "false" como true). */
export const queryBoolean = z
  .union([z.boolean(), z.string()])
  .transform((v) => (typeof v === 'boolean' ? v : ['true', '1', 'yes', 'on'].includes(v.trim().toLowerCase())));

export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
export type Pagination = z.infer<typeof paginationSchema>;

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export const idParam = z.object({ id: uuidSchema });
